module.exports = __webpack_public_path__ + "media/customizations/wilderranch/logo-new-8e35f25bf8ff386c34e0e8fc8701e58d.png";